// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const onix: PokeData = {
  "id": 95,
  "name": "onix",
  "height": 88,
  "weight": 2100,
  "base_experience": 77,
  "types": [
    PokeType.ROCK,
    PokeType.GROUND
  ],
  "api_moves": [
    "bind",
    "slam",
    "tackle",
    "double-edge",
    "rock-throw",
    "earthquake",
    "dig",
    "rage",
    "screech",
    "harden",
    "rock-slide",
    "curse",
    "sandstorm",
    "rollout",
    "dragon-breath",
    "iron-tail",
    "mud-sport",
    "rock-tomb",
    "sand-tomb",
    "gyro-ball",
    "rock-polish",
    "stone-edge",
    "stealth-rock",
    "smack-down",
    "bulldoze",
    "high-horsepower"
  ],
  "moves": [
    "tackle",
    "rock-throw",
    "earthquake",
    "rock-slide",
    "curse",
    "sandstorm",
    "dragon-breath",
    "rock-tomb",
    "stealth-rock",
    "stone-axe",
    "fissure",
    "rototiller",
    "bone-throw"
  ],
  "evolution_chain": {
    "id": 41,
    "item": null,
    "species": [
      {
        "name": "onix",
        "order": 103,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "steelix",
        "order": 104,
        "types": [
          PokeType.STEEL,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 95,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 68.75,
    "speed": 70,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
